import React, { useState, useEffect } from 'react';

const OfflineNotification = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 Conexión restaurada');
      setIsOffline(false);
      setShowNotification(false);
    };

    const handleOffline = () => {
      console.log('📴 Sin conexión a internet');
      setIsOffline(true);
      setShowNotification(true);
    };

    // Listeners para cambios de conectividad
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Verificar estado inicial
    if (!navigator.onLine) {
      setIsOffline(true);
      setShowNotification(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Auto-ocultar notificación después de 10 segundos
  useEffect(() => {
    if (showNotification && isOffline) {
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [showNotification, isOffline]);

  if (!isOffline || !showNotification) {
    return null;
  }

  return (
    <div
      className="fixed left-1/2 transform -translate-x-1/2 z-[9999] animate-slide-down"
      style={{
        top: 'max(env(safe-area-inset-top) + 80px, 100px)',
        maxWidth: '90%',
        width: '520px'
      }}
    >
      <div
        className="bg-white text-gray-800 px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-4"
        style={{
          border: '3px solid #f59e0b',
          boxShadow: '0 10px 40px rgba(245, 158, 11, 0.3)'
        }}
      >
        <div className="text-3xl">📴</div>
        <div className="flex-1">
          <div className="font-bold text-base mb-1">
            Sin conexión a internet
          </div>
          <div className="text-sm text-gray-600">
            Mostrando contenido guardado. Algunas funciones pueden no estar disponibles.
          </div>
        </div>
        <button
          onClick={() => setShowNotification(false)}
          className="text-gray-400 hover:text-gray-600 text-2xl font-bold leading-none"
          aria-label="Cerrar"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default OfflineNotification;

